<script setup lang="ts">
export interface InfoBlockItem {
    hideDot?: boolean;
    spec?: string;
    text?: string;
    boldness?: "normal" | "medium" | "bold";
}

export interface PackInfoBlockProp {
    color?: "primary" | "bronze" | "silver" | "gold";
    icon?: string;
    title?: string;
    items: InfoBlockItem[];
}

const props = withDefaults(defineProps<PackInfoBlockProp>(), {
    color: "primary",
    items: () => {
        return new Array<InfoBlockItem>();
    },
});
</script>
<template>
    <div class="grid-layout">
        <img :src="props.icon" alt="Kart" class="icon-block" />
        <p
            class="title-block is-uppercase ml-5 mb-2 is-weight-600 is-family-code is-size-4"
            :class="[`has-text-${props.color}`]">
            {{ props.title }}
        </p>
        <p
            v-for="(item, index) in props.items"
            :key="index"
            class="item-block has-text-white is-uppercase mb-2 ml-5 is-weight-400">
            <span v-if="!item.hideDot" :class="[`has-text-${props.color}`]">
                •&nbsp;
            </span>
            <span
                :class="[`has-text-${props.color}`, `has-text-weight-${item.boldness}`]"
                >{{ item.spec }}</span
            >
            {{ item.text }}
        </p>
    </div>
</template>

<style lang="scss" scoped>
.grid-layout {
    display: grid;
    font-size: 1.25rem;
    height: fit-content;
    grid-template-rows: repeat(v-bind("props.items.length + 1"), auto);
    grid-template-columns: 70px 1fr;

    > .icon-block {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: v-bind("props.items.length + 2");
    }

    > .title-block {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 2;
    }
}

@media screen and (max-width: 700px) {
    .grid-layout {
        display: grid;
        grid-template-rows: repeat(v-bind("props.items.length + 2"), auto);
        grid-template-columns: 70px 1fr;

        > .icon-block {
            grid-column-start: 1;
            grid-column-end: 2;
            grid-row-start: 1;
            grid-row-end: 2;
        }

        > .title-block {
            grid-column-start: 2;
            grid-column-end: 3;
            grid-row-start: 1;
            grid-row-end: 2;
            margin-top: auto;
            margin-bottom: auto;
            margin-left: 0.25rem !important;

            + .item-block {
                margin-top: 1rem;
            }
        }

        > .item-block {
            grid-column-start: 1;
            grid-column-end: 3;
        }
    }
}

.w-100 {
    width: 100%;
}

.icon-block {
    max-width: 70px;
}

.is-size-content {
    font-size: 1.5rem;
}

@media screen and (max-width: 700px) {
    .icon-block {
        max-width: 50px;
    }

    .is-size-content {
        font-size: 1.2rem;
    }
}
</style>